import React, { useState } from "react";
import Trash from '../../../assets/images/comman/trash-outline.svg'

const DoctorAssessment = () => {


    const createNewItem = () => ({
        id: Date.now(),
    });

    const [medicalHisToryitems, setMedicalHisToryitems] = useState([createNewItem()]);
    const handleMedicalHistory = () => {
        setMedicalHisToryitems((prev) => [...prev, createNewItem()]);
    }
    const handleRemoveMedicalHistory = (id) => {
        if (medicalHisToryitems.length > 1) {
            setMedicalHisToryitems((prev) => prev.filter((medicalHisToryitems) => medicalHisToryitems.id !== id));
        }
    };
    // End Medical History


    const [medicalSurgicalitems, setMedicalSurgicalitems] = useState([createNewItem()]);
    const handleSurgicalHistory = () => {
        setMedicalSurgicalitems((prev) => [...prev, createNewItem()]);
    }
    const handleRemoveSurgicalHistory = (id) => {
        if (medicalSurgicalitems.length > 1) {
            setMedicalSurgicalitems((prev) => prev.filter((medicalSurgicalitems) => medicalSurgicalitems.id !== id));
        }
    };
    // End Surgical History


    const [additionalDetails, setAdditionalDetails] = useState([createNewItem()]);
    const handleAdditionalDetails = () => {
        setAdditionalDetails((prev) => [...prev, createNewItem()]);
    }
    const handleRemoveAdditionalDetail = (id) => {
        if (additionalDetails.length > 1) {
            setAdditionalDetails((prev) => prev.filter((additionalDetails) => additionalDetails.id !== id));
        }
    };
    // End Additional Details

    const [addPersonalHistory, setAddPersonalHistory] = useState([createNewItem()]);
    const handlePersonalHistory = () => {
        setAddPersonalHistory((prev) => [...prev, createNewItem()]);
    }
    const handleRemovehandlePersonalHistory = (id) => {
        if (addPersonalHistory.length > 1) {
            setAddPersonalHistory((prev) => prev.filter((addPersonalHistory) => addPersonalHistory.id !== id));
        }
    };

    const [dataConsent, setDataConsent] = useState(false);

    return (
        <>
            <div className="container-fluid">
                <div className="assessment-page">
                    <div className="allMainFeilds">
                        <div className="basicDetails">
                            <h4>Vitals Details</h4>
                            <div className="patientsFeildsRow">
                                <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Pulse (BPM)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">SPO2%</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">SBP(mmHg)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">DBP(mmHg)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">MAP</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Temp (S)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Res (bpm) </label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Pain Score</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Height (CM)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Weight (KG)</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">BSA</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">BMI</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Category</label>
                                            <select>
                                                <option>Select</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">BS</label>
                                            <select>
                                                <option>Select</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Creatinine </label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">eGFR</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">eGFR</label>
                                            <input type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="basicDetails">
                            <div className="patientsFeildsRow">
                                <div className="row">
                                    <div className="col-xs-12 col-md-5">
                                        <div className="feilds">
                                            <label className="label">Symptoms / Complaints</label>
                                            <textarea rows="6"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <div className="feilds">
                                            <label className="label">Select Symptoms</label>
                                            <select>
                                                <option>Select</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Medical History</h4>
                            <div className="patientsFeildsRow">
                                {medicalHisToryitems.map((medicalHisToryitemsItem, index) => (
                                    <div className="row">
                                        <div className="col-xs-12 col-md-3">
                                            <div className="feilds">
                                                <label className="label">Diseases</label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-3">
                                            <div className="feilds">
                                                <label className="label">Duration </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-3">
                                            <div className="feilds">
                                                <label className="label">Medications  </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-3">
                                            <div className="feilds">
                                                <label className="label">&nbsp;  </label>
                                                <div className="trashSection" onClick={() => handleRemoveMedicalHistory(medicalHisToryitemsItem.id)}>
                                                    <img src={Trash} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="add-items">
                                    <button className="customeBtn btnLightBlueBorder" onClick={handleMedicalHistory}>+ Add Item</button>
                                </div>

                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Surgical History</h4>
                            <div className="patientsFeildsRow">
                                {medicalSurgicalitems.map((medicalSurgicalitems, index) => (
                                    <div className="row">
                                        <div className="col-xs-12 col-md-6">
                                            <div className="row">
                                                <div className="col-xs-12 col-md-6">
                                                    <div className="feilds">
                                                        <label className="label">Surgical</label>
                                                        <select>
                                                            <option>Select</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-md-6">
                                                    <div className="feilds">
                                                        <label className="label">Surgeon Name  </label>
                                                        <input type="text" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12 col-md-6">
                                                    <div className="feilds">
                                                        <label className="label">Date  </label>
                                                        <input type="date" />
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-md-6">
                                                    <div className="feilds">
                                                        <label className="label">Hospital  </label>
                                                        <input type="text" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-3">
                                            <div className="feilds">
                                                <label className="label">&nbsp;  </label>
                                                <div className="trashSection" onClick={() => handleRemoveSurgicalHistory(medicalSurgicalitems.id)}>
                                                    <img src={Trash} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="add-items">
                                    <button className="customeBtn btnLightBlueBorder" onClick={handleSurgicalHistory}>+ Add Item</button>
                                </div>

                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Additional Details</h4>
                            <div className="patientsFeildsRow">
                                {additionalDetails.map((additionalDetails, index) => (
                                    <div className="row">
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Type </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Duration </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Units   </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Frequency  </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Action   </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-1">
                                            <div className="feilds">
                                                <label className="label">&nbsp;  </label>
                                                <div className="trashSection" onClick={() => handleRemoveAdditionalDetail(additionalDetails.id)}>
                                                    <img src={Trash} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="add-items">
                                    <button className="customeBtn btnLightBlueBorder" onClick={handleAdditionalDetails}>+ Add Item</button>
                                </div>

                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Immunization Record</h4>
                            <div className="patientsFeildsRow">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-8">
                                                <div className="feilds">
                                                    <select>
                                                        <option>COVID-19 Vaccine (Dose 1)</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <div className="feilds">
                                                    <input type="date" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 col-md-8">
                                                <div className="feilds">
                                                    <select>
                                                        <option>COVID-19 Vaccine (Dose 2)</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <div className="feilds">
                                                    <input type="date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-8">
                                                <div className="feilds">
                                                    <select>
                                                        <option>Tetanus Booster</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <div className="feilds">
                                                    <input type="date" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 col-md-8">
                                                <div className="feilds">
                                                    <select>
                                                        <option>Flu Vaccine</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <div className="feilds">
                                                    <input type="date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Personal History</h4>
                            <div className="patientsFeildsRow">
                                {addPersonalHistory.map((addPersonalHistoryItems, index) => (
                                    <div className="row">
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Diet  </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Appetite </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Sleep   </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Blader   </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-2">
                                            <div className="feilds">
                                                <label className="label">Bowel   </label>
                                                <select>
                                                    <option>Select</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-1">
                                            <div className="feilds">
                                                <label className="label">&nbsp;  </label>
                                                <div className="trashSection" onClick={() => handleRemovehandlePersonalHistory(addPersonalHistoryItems.id)}>
                                                    <img src={Trash} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="add-items">
                                    <button className="customeBtn btnLightBlueBorder" onClick={handlePersonalHistory}>+ Add Item</button>
                                </div>

                            </div>
                        </div>
                        <div className="basicDetails">
                            <h4>Document Upload</h4>
                            <div className="patientsFeildsRow" style={{ minHeight: '170px' }}>
                                <div className="row">
                                    <div className="col-xs-12 col-md-12">
                                        <div className="uploads">
                                            <input type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" />
                                            <h5>Upload file</h5>
                                            <p>Drag & drop files here or click to upload</p>
                                            <h6>(PDF, JPG, PNG up to 10MB)</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="agreeCheck">
                            <div className="row">
                                <div className="col-xs-12 col-md-12">
                                    <div className="feilds">
                                        <label className="checkBoxCustome" style={{ cursor: "pointer" }}>
                                            <h4>I consent to sharing this non-clinical health data with ABDM.</h4>
                                            <input
                                                type="checkbox"
                                                checked={dataConsent}
                                                onChange={(e) => setDataConsent(e.target.checked)}
                                            />
                                            <span className="checkmark" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="basicDetailsAction">
                            {/* <button className="customeBtn btnEmpty me-2">Save Locally</button>
                            <button className="customeBtn btnEmpty me-2">Download PDF</button>
                            <button className="customeBtn btnLightBlue me-2">Share to ABDM</button>
                            <button className="customeBtn btnLightBlue">Save</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DoctorAssessment





// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { saveVitals, getLatestVitals } from '../../../Services/api';
// import ToastContainer, { useToast } from '../../../components/common/ToastContainer';
// import Trash from '../../../assets/images/comman/trash-outline.svg'

// const DoctorAssessment = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { toasts, removeToast, showSuccess, showError } = useToast();
    
//     // Patient data from navigation state
//     const [patientData, setPatientData] = useState(null);
//     const [isLoadingVitals, setIsLoadingVitals] = useState(false);
//     const [isSavingVitals, setIsSavingVitals] = useState(false);

//     // Vitals state - all input fields that can be filled
//     const [vitalsData, setVitalsData] = useState({
//         // Basic vitals
//         pulse: '',
//         spo2: '',
//         sbp: '',
//         dbp: '',
//         map: '',
//         temperature: '',
//         respiratory: '',
//         painScore: '',
//         height: '',
//         weight: '',
//         bsa: '',
//         bmi: '',
//         category: '',
//         bs: '',
//         creatinine: '',
//         egfr: '',
//         // Symptoms
//         symptoms: '',
//         selectedSymptoms: ''
//     });

//     // Function to fetch latest vitals for the patient
//     const fetchLatestVitalsData = async (patient) => {
//         if (!patient) return;
        
//         setIsLoadingVitals(true);
//         try {
//             // Get clean ABHA number
//             const cleanAbhaNumber = (patient.formattedAbhaId || patient.abhaNumber || '').replace(/-/g, '').replace(/\s/g, '');
            
//             if (cleanAbhaNumber) {
//                 const response = await getLatestVitals(cleanAbhaNumber);
                
//                 if (response.success && response.data?.vitals?.input) {
//                     // Map the API response to our vitals state
//                     const newVitalsData = { ...vitalsData };
                    
//                     response.data.vitals.input.forEach(item => {
//                         // Map field names from API to our state keys
//                         const fieldMapping = {
//                             'Pulse (BPM)': 'pulse',
//                             'SPO2%': 'spo2', 
//                             'SBP(mmHg)': 'sbp',
//                             'DBP(mmHg)': 'dbp',
//                             'MAP': 'map',
//                             'Temp (S)': 'temperature',
//                             'Res (bpm)': 'respiratory',
//                             'Pain Score': 'painScore',
//                             'Height (CM)': 'height',
//                             'Weight (KG)': 'weight',
//                             'BSA': 'bsa',
//                             'BMI': 'bmi',
//                             'Category': 'category',
//                             'BS': 'bs',
//                             'Creatinine': 'creatinine',
//                             'eGFR': 'egfr',
//                             'Symptoms / Complaints': 'symptoms',
//                             'Select Symptoms': 'selectedSymptoms'
//                         };
                        
//                         const mappedKey = fieldMapping[item.fieldName];
//                         if (mappedKey) {
//                             newVitalsData[mappedKey] = item.fieldValue || '';
//                         }
//                     });
                    
//                     setVitalsData(newVitalsData);
//                     showSuccess('Latest vitals loaded successfully');
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching latest vitals:', error);
//             // Don't show error for missing vitals as it's expected for new patients
//         } finally {
//             setIsLoadingVitals(false);
//         }
//     };

//     // Function to handle vitals input changes
//     const handleVitalsChange = (field, value) => {
//         setVitalsData(prev => ({
//             ...prev,
//             [field]: value
//         }));
//     };

//     // Function to collect all form data and save vitals
//     const saveVitalsData = async () => {
//         if (!patientData) {
//             showError('Patient data not available');
//             return;
//         }

//         setIsSavingVitals(true);
//         try {
//             // Get clean ABHA number
//             const cleanAbhaNumber = (patientData.formattedAbhaId || patientData.abhaNumber || '').replace(/-/g, '').replace(/\s/g, '');
            
//             if (!cleanAbhaNumber) {
//                 showError('ABHA number not available for this patient');
//                 return;
//             }

//             // Collect all form field values dynamically
//             const assessmentPage = document.querySelector('.assessment-page');
//             const allFormFields = [];

//             if (assessmentPage) {
//                 // Get all input fields
//                 const inputs = assessmentPage.querySelectorAll('input[type="text"], input[type="number"]');
//                 inputs.forEach(input => {
//                     const label = input.closest('.feilds')?.querySelector('label')?.textContent?.trim() || '';
//                     if (label && input.value) {
//                         allFormFields.push({
//                             fieldName: label,
//                             fieldValue: input.value,
//                             fieldType: input.type === 'number' ? 'number' : 'string'
//                         });
//                     }
//                 });

//                 // Get all select dropdowns
//                 const selects = assessmentPage.querySelectorAll('select');
//                 selects.forEach(select => {
//                     const label = select.closest('.feilds')?.querySelector('label')?.textContent?.trim() || '';
//                     const selectedOption = select.options[select.selectedIndex];
//                     if (label && selectedOption && selectedOption.value && selectedOption.value !== 'Select') {
//                         allFormFields.push({
//                             fieldName: label,
//                             fieldValue: selectedOption.text,
//                             fieldType: 'string'
//                         });
//                     }
//                 });

//                 // Get all textareas
//                 const textareas = assessmentPage.querySelectorAll('textarea');
//                 textareas.forEach(textarea => {
//                     const label = textarea.closest('.feilds')?.querySelector('label')?.textContent?.trim() || '';
//                     if (label && textarea.value) {
//                         allFormFields.push({
//                             fieldName: label,
//                             fieldValue: textarea.value,
//                             fieldType: 'string'
//                         });
//                     }
//                 });
//             }

//             // Prepare vitals data for API
//             const vitalsPayload = {
//                 abhaNumber: cleanAbhaNumber,
//                 abhaAddress: patientData.ABHAAddress || patientData.abhaAddress || patientData.abhaaddress || patientData.abha_address || `${cleanAbhaNumber}@sbx`,
//                 name: patientData.fullName || patientData.name || '',
//                 gender: patientData.gender || 'M',
//                 yearOfBirth: patientData.yearOfBirth || new Date().getFullYear() - (patientData.calculatedAge || 30),
//                 input: allFormFields
//             };

//             const response = await saveVitals(vitalsPayload);
            
//             if (response.success) {
//                 showSuccess(response.message || 'Vitals saved successfully');
//             } else {
//                 showError(response.message || 'Failed to save vitals');
//             }
//         } catch (error) {
//             console.error('Error saving vitals:', error);
//             showError(`Failed to save vitals: ${error.message}`);
//         } finally {
//             setIsSavingVitals(false);
//         }
//     };


//     const createNewItem = () => ({
//         id: Date.now(),
//     });

//     const [medicalHisToryitems, setMedicalHisToryitems] = useState([createNewItem()]);
//     const handleMedicalHistory = () => {
//         setMedicalHisToryitems((prev) => [...prev, createNewItem()]);
//     }
//     const handleRemoveMedicalHistory = (id) => {
//         if (medicalHisToryitems.length > 1) {
//             setMedicalHisToryitems((prev) => prev.filter((medicalHisToryitems) => medicalHisToryitems.id !== id));
//         }
//     };
//     // End Medical History


//     const [medicalSurgicalitems, setMedicalSurgicalitems] = useState([createNewItem()]);
//     const handleSurgicalHistory = () => {
//         setMedicalSurgicalitems((prev) => [...prev, createNewItem()]);
//     }
//     const handleRemoveSurgicalHistory = (id) => {
//         if (medicalSurgicalitems.length > 1) {
//             setMedicalSurgicalitems((prev) => prev.filter((medicalSurgicalitems) => medicalSurgicalitems.id !== id));
//         }
//     };
//     // End Surgical History


//     const [additionalDetails, setAdditionalDetails] = useState([createNewItem()]);
//     const handleAdditionalDetails = () => {
//         setAdditionalDetails((prev) => [...prev, createNewItem()]);
//     }
//     const handleRemoveAdditionalDetail = (id) => {
//         if (additionalDetails.length > 1) {
//             setAdditionalDetails((prev) => prev.filter((additionalDetails) => additionalDetails.id !== id));
//         }
//     };
//     // End Additional Details

//     const [addPersonalHistory, setAddPersonalHistory] = useState([createNewItem()]);
//     const handlePersonalHistory = () => {
//         setAddPersonalHistory((prev) => [...prev, createNewItem()]);
//     }
//     const handleRemovehandlePersonalHistory = (id) => {
//         if (addPersonalHistory.length > 1) {
//             setAddPersonalHistory((prev) => prev.filter((addPersonalHistory) => addPersonalHistory.id !== id));
//         }
//     };


//     return (
//         <>
//             <div className="container-fluid">
//                 <div className="assessment-page">
//                     {isLoadingVitals && (
//                         <div style={{ 
//                             marginBottom: '20px', 
//                             padding: '10px', 
//                             backgroundColor: '#f0f8ff', 
//                             border: '1px solid #0066cc', 
//                             borderRadius: '5px',
//                             textAlign: 'center'
//                         }}>
//                             <strong>🔄 Loading latest vitals...</strong>
//                         </div>
//                     )}
//                     {patientData && (
//                         <div style={{ 
//                             marginBottom: '20px', 
//                             padding: '10px', 
//                             backgroundColor: '#e8f5e8', 
//                             border: '1px solid #2e7d2e', 
//                             borderRadius: '5px'
//                         }}>
//                             <strong>Patient: {patientData.fullName || patientData.name || 'Unknown'}</strong>
//                             <div style={{ fontSize: '12px', marginTop: '5px', color: '#2e7d2e' }}>
//                                 ABHA: {patientData.formattedAbhaId || patientData.abhaNumber || 'N/A'} | Age: {patientData.calculatedAge || 'N/A'} | Gender: {patientData.gender || 'N/A'}
//                             </div>
//                         </div>
//                     )}
//                     <div className="allMainFeilds">
//                         <div className="basicDetails">
//                             <h4>Vitals Details</h4>
//                             <div className="patientsFeildsRow">
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Pulse (BPM)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.pulse}
//                                                 onChange={(e) => handleVitalsChange('pulse', e.target.value)}
//                                                 placeholder="Enter pulse rate"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">SPO2%</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.spo2}
//                                                 onChange={(e) => handleVitalsChange('spo2', e.target.value)}
//                                                 placeholder="Enter SPO2"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">SBP(mmHg)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.sbp}
//                                                 onChange={(e) => handleVitalsChange('sbp', e.target.value)}
//                                                 placeholder="Enter SBP"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">DBP(mmHg)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.dbp}
//                                                 onChange={(e) => handleVitalsChange('dbp', e.target.value)}
//                                                 placeholder="Enter DBP"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">MAP</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.map}
//                                                 onChange={(e) => handleVitalsChange('map', e.target.value)}
//                                                 placeholder="Enter MAP"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Temp (S)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.temperature}
//                                                 onChange={(e) => handleVitalsChange('temperature', e.target.value)}
//                                                 placeholder="Enter temperature"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Res (bpm) </label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.respiratory}
//                                                 onChange={(e) => handleVitalsChange('respiratory', e.target.value)}
//                                                 placeholder="Enter respiratory rate"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Pain Score</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.painScore}
//                                                 onChange={(e) => handleVitalsChange('painScore', e.target.value)}
//                                                 placeholder="Enter pain score"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Height (CM)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.height}
//                                                 onChange={(e) => handleVitalsChange('height', e.target.value)}
//                                                 placeholder="Enter height"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Weight (KG)</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.weight}
//                                                 onChange={(e) => handleVitalsChange('weight', e.target.value)}
//                                                 placeholder="Enter weight"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">BSA</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.bsa}
//                                                 onChange={(e) => handleVitalsChange('bsa', e.target.value)}
//                                                 placeholder="Enter BSA"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">BMI</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.bmi}
//                                                 onChange={(e) => handleVitalsChange('bmi', e.target.value)}
//                                                 placeholder="Enter BMI"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Category</label>
//                                             <select 
//                                                 value={vitalsData.category}
//                                                 onChange={(e) => handleVitalsChange('category', e.target.value)}
//                                             >
//                                                 <option value="">Select</option>
//                                                 <option value="Normal">Normal</option>
//                                                 <option value="Underweight">Underweight</option>
//                                                 <option value="Overweight">Overweight</option>
//                                                 <option value="Obese">Obese</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">BS</label>
//                                             <select 
//                                                 value={vitalsData.bs}
//                                                 onChange={(e) => handleVitalsChange('bs', e.target.value)}
//                                             >
//                                                 <option value="">Select</option>
//                                                 <option value="Normal">Normal</option>
//                                                 <option value="High">High</option>
//                                                 <option value="Low">Low</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Creatinine </label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.creatinine}
//                                                 onChange={(e) => handleVitalsChange('creatinine', e.target.value)}
//                                                 placeholder="Enter creatinine"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">eGFR</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.egfr}
//                                                 onChange={(e) => handleVitalsChange('egfr', e.target.value)}
//                                                 placeholder="Enter eGFR"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">eGFR</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={vitalsData.egfr}
//                                                 onChange={(e) => handleVitalsChange('egfr', e.target.value)}
//                                                 placeholder="Enter additional eGFR"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <div className="patientsFeildsRow">
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-5">
//                                         <div className="feilds">
//                                             <label className="label">Symptoms / Complaints</label>
//                                             <textarea 
//                                                 rows="6"
//                                                 value={vitalsData.symptoms}
//                                                 onChange={(e) => handleVitalsChange('symptoms', e.target.value)}
//                                                 placeholder="Enter patient symptoms and complaints"
//                                             ></textarea>
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-3">
//                                         <div className="feilds">
//                                             <label className="label">Select Symptoms</label>
//                                             <select 
//                                                 value={vitalsData.selectedSymptoms}
//                                                 onChange={(e) => handleVitalsChange('selectedSymptoms', e.target.value)}
//                                             >
//                                                 <option value="">Select</option>
//                                                 <option value="Fever">Fever</option>
//                                                 <option value="Cough">Cough</option>
//                                                 <option value="Headache">Headache</option>
//                                                 <option value="Fatigue">Fatigue</option>
//                                                 <option value="Nausea">Nausea</option>
//                                                 <option value="Chest Pain">Chest Pain</option>
//                                                 <option value="Shortness of Breath">Shortness of Breath</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <h4>Medical History</h4>
//                             <div className="patientsFeildsRow">
//                                 {medicalHisToryitems.map((medicalHisToryitemsItem, index) => (
//                                     <div className="row">
//                                         <div className="col-xs-12 col-md-3">
//                                             <div className="feilds">
//                                                 <label className="label">Diseases</label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-3">
//                                             <div className="feilds">
//                                                 <label className="label">Duration </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-3">
//                                             <div className="feilds">
//                                                 <label className="label">Medications  </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-3">
//                                             <div className="feilds">
//                                                 <label className="label">&nbsp;  </label>
//                                                 <div className="trashSection" onClick={() => handleRemoveMedicalHistory(medicalHisToryitemsItem.id)}>
//                                                     <img src={Trash} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div className="add-items">
//                                     <button className="customeBtn btnLightBlueBorder" onClick={handleMedicalHistory}>+ Add Item</button>
//                                 </div>

//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <h4>Surgical History</h4>
//                             <div className="patientsFeildsRow">
//                                 {medicalSurgicalitems.map((medicalSurgicalitems, index) => (
//                                     <div className="row">
//                                         <div className="col-xs-12 col-md-6">
//                                             <div className="row">
//                                                 <div className="col-xs-12 col-md-6">
//                                                     <div className="feilds">
//                                                         <label className="label">Surgical</label>
//                                                         <select>
//                                                             <option>Select</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-xs-12 col-md-6">
//                                                     <div className="feilds">
//                                                         <label className="label">Surgeon Name  </label>
//                                                         <input type="text" />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="row">
//                                                 <div className="col-xs-12 col-md-6">
//                                                     <div className="feilds">
//                                                         <label className="label">Date  </label>
//                                                         <input type="date" />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-xs-12 col-md-6">
//                                                     <div className="feilds">
//                                                         <label className="label">Hospital  </label>
//                                                         <input type="text" />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-3">
//                                             <div className="feilds">
//                                                 <label className="label">&nbsp;  </label>
//                                                 <div className="trashSection" onClick={() => handleRemoveSurgicalHistory(medicalSurgicalitems.id)}>
//                                                     <img src={Trash} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div className="add-items">
//                                     <button className="customeBtn btnLightBlueBorder" onClick={handleSurgicalHistory}>+ Add Item</button>
//                                 </div>

//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <h4>Additional Details</h4>
//                             <div className="patientsFeildsRow">
//                                 {additionalDetails.map((additionalDetails, index) => (
//                                     <div className="row">
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Type </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Duration </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Units   </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Frequency  </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Action   </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-1">
//                                             <div className="feilds">
//                                                 <label className="label">&nbsp;  </label>
//                                                 <div className="trashSection" onClick={() => handleRemoveAdditionalDetail(additionalDetails.id)}>
//                                                     <img src={Trash} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div className="add-items">
//                                     <button className="customeBtn btnLightBlueBorder" onClick={handleAdditionalDetails}>+ Add Item</button>
//                                 </div>

//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <h4>Immunization Record</h4>
//                             <div className="patientsFeildsRow">
//                                 <div className="row">
//                                     <div className="col-xs-12 col-md-6">
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-8">
//                                                 <div className="feilds">
//                                                     <select>
//                                                         <option>COVID-19 Vaccine (Dose 1)</option>
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xs-12 col-md-4">
//                                                 <div className="feilds">
//                                                     <input type="date" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-8">
//                                                 <div className="feilds">
//                                                     <select>
//                                                         <option>COVID-19 Vaccine (Dose 2)</option>
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xs-12 col-md-4">
//                                                 <div className="feilds">
//                                                     <input type="date" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-xs-12 col-md-6">
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-8">
//                                                 <div className="feilds">
//                                                     <select>
//                                                         <option>Tetanus Booster</option>
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xs-12 col-md-4">
//                                                 <div className="feilds">
//                                                     <input type="date" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-8">
//                                                 <div className="feilds">
//                                                     <select>
//                                                         <option>Flu Vaccine</option>
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xs-12 col-md-4">
//                                                 <div className="feilds">
//                                                     <input type="date" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="basicDetails">
//                             <h4>Personal History</h4>
//                             <div className="patientsFeildsRow">
//                                 {addPersonalHistory.map((addPersonalHistoryItems, index) => (
//                                     <div className="row">
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Diet  </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Appetite </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Sleep   </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Blader   </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-2">
//                                             <div className="feilds">
//                                                 <label className="label">Bowel   </label>
//                                                 <select>
//                                                     <option>Select</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <div className="col-xs-12 col-md-1">
//                                             <div className="feilds">
//                                                 <label className="label">&nbsp;  </label>
//                                                 <div className="trashSection" onClick={() => handleRemovehandlePersonalHistory(addPersonalHistoryItems.id)}>
//                                                     <img src={Trash} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div className="add-items">
//                                     <button className="customeBtn btnLightBlueBorder" onClick={handlePersonalHistory}>+ Add Item</button>
//                                 </div>

//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-xs-12 col-md-6">
//                                 <div className="basicDetails">
//                                     <h4>Document Upload</h4>
//                                     <div className="patientsFeildsRow" style={{ minHeight: '170px' }}>
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-12">
//                                                 <div className="uploads">
//                                                     <input type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" />
//                                                     <h5>Upload file</h5>
//                                                     <p>Drag & drop files here or click to upload</p>
//                                                     <h6>(PDF, JPG, PNG up to 10MB)</h6>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xs-12 col-md-6">
//                                 <div className="basicDetails">
//                                     <h4>Data Sharing Consent</h4>
//                                     <div className="patientsFeildsRow" style={{ minHeight: '170px' }}>
//                                         <div className="row">
//                                             <div className="col-xs-12 col-md-12">
//                                                 <div className="feilds">
//                                                     <label className="checkBoxCustome">
//                                                         <h4>I consent to sharing this non-clinical health data with ABDM.  </h4>
//                                                         <input type="checkbox" />
//                                                         <span className="checkmark" />
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="basicDetailsAction">
//                             <button className="customeBtn btnEmpty me-2">Save Locally</button>
//                             <button className="customeBtn btnEmpty me-2">Download PDF</button>
//                             <button className="customeBtn btnLightBlue me-2">Share to ABDM</button>
//                             <button 
//                                 className="customeBtn btnLightBlue"
//                                 onClick={saveVitalsData}
//                                 disabled={isSavingVitals || !patientData}
//                                 style={{
//                                     opacity: isSavingVitals ? 0.6 : 1,
//                                     cursor: isSavingVitals ? 'not-allowed' : 'pointer'
//                                 }}
//                             >
//                                 {isSavingVitals ? 'Saving...' : 'Save'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <ToastContainer toasts={toasts} removeToast={removeToast} />
//         </>
//     )
// }

// export default DoctorAssessment